import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux';
import config from '../config';
import { arrondir } from '../librairie';
import { setTheme2, setAlerte } from '../redux/actions';

function Theme2({ listethematiques, jeton, theme2, setTheme2, territoire }) {

    const [afficherbulleinformation, setAfficherBulleInformation] = useState(false);
    const [theme, setTheme] = useState("");
    const [variable, setVariable] = useState("");
    const [signe, setSigne] = useState("inf");
    const [valeurtest, setValeurTest] = useState("");
    const [valeursaisie, setValeurSaisie] = useState("");
    const [siActiver, setSiActiver] = useState(false);
    const [valeurs, setValeurs] = useState({ min: 0, max: 0, mediane: 0 });

    useEffect(() => {
        try {
            if (siActiver&&variable !== "") {
                // eslint-disable-next-line
                var element = listethematiques.filter(a => a.id == variable);
                if (typeof element !== undefined && Array.isArray(element) && element.length > 0) {
                    var colonne = element[0].colonne;
                    fetch(`${config.serveur}bdd/maille/SELECT min(${colonne}) min, max(${colonne}) max,percentile_disc(0.5) WITHIN GROUP (ORDER BY ${colonne}) mediane FROM maille.mailles `,
                        {
                            headers: {
                                "Authorization": jeton
                            }
                        }
                    )
                        .then(result => result.json())
                        .then(result => {
                            if (Array.isArray(result) && result.length > 0) {
                                setValeurs(result[0]);
                            }
                        })
                }
            }
        }
        catch (error) {
            console.log(error)
        }
        // eslint-disable-next-line
    }, [variable])

    const changeTheme = (val) => {
        if (val.target.value === "") { setSiActiver(false) }
        else {
            setSiActiver(true);
        }
        setTheme(val.target.value);
        // eslint-disable-next-line
        setVariable(listethematiques.filter(a => a.precedent == val.target.value)[0].id);
        enregistrer();
    }

    const changeVariable = (val) => {
        setVariable(val.target.value);
        enregistrer();
    }

    const changeSigne = (val) => {
        setSigne(val.target.value);
        enregistrer();
    }

    const changeValeurTest = (val) => {
        setValeurTest(val.target.value);
        enregistrer();
    }

    const changeValeurSaisie = (val) => {
        setValeurSaisie(val.target.value);
        enregistrer();
    }

    let variablecomplete = "";
    // eslint-disable-next-line
    variablecomplete = listethematiques.filter(a => a.id == variable);
    if (variablecomplete.length > 0) {
        variablecomplete = variablecomplete[0];
    }
    else {
        variablecomplete = "";
    }

    const enregistrer = () => {
        setTheme2({
            theme: variablecomplete.id,
            variable,
            signe,
            valeurtest,
            valeursaisie,
            ...variablecomplete,
        });
    }


    useEffect(() => {
        if (siActiver) {
            setTheme2({
                theme: variablecomplete.id,
                variable,
                signe,
                valeurtest,
                valeursaisie,
                ...variablecomplete,
            });
        }
        else {
            if (theme2) {
                setTheme2();
            }
        }
        // eslint-disable-next-line
    }, [siActiver, variablecomplete.id, variable, signe, valeurtest, valeursaisie])


    const valeurafficher = {
        q1: territoire === "BDR" ? variablecomplete.quantile25_dep : variablecomplete.quantile25_amp,
        q2: territoire === "BDR" ? variablecomplete.quantile50_dep : variablecomplete.quantile50_amp,
        q3: territoire === "BDR" ? variablecomplete.quantile75_dep : variablecomplete.quantile75_amp,
        moyenne: territoire === "BDR" ? variablecomplete.moyenne_dep : variablecomplete.moyenne_amp,
        unite: variablecomplete.unite,
    }

    useEffect(() => {
        setValeurTest(territoire === "BDR" ? variablecomplete.quantile25_dep : variablecomplete.quantile25_amp);
    }, [territoire, variablecomplete.quantile25_dep, variablecomplete.quantile25_amp]);


    return (
        <>
            <div className="col-12 tuile ombre">
                <div className="row">
                    <div className="col-1 sansmarge">
                        <img id="fleche1" src={`${process.env.PUBLIC_URL}/images/tribas.png`} alt="" className="fleche" />
                        <input type="checkbox" id="afficher1" checked={siActiver} onChange={() => { if (theme !== "") { setSiActiver(!siActiver) } else { setAlerte("Vous devez d'abord sélectioner la thématique", "warning") } }} />
                        <div className="couleurtheme">
                            <div style={{ backgroundColor: "var(--theme2)" }}></div>
                        </div>
                    </div>
                    <div className="col-11 sansmarge">
                        <div style={{ width: "100%", textAlign: "right !important" }}>
                            Thématique :
                            <select id="theme2" className="semi-square" value={theme} onChange={changeTheme}>
                                <option value="" >Choisissez un thème</option>
                                {
                                    // eslint-disable-next-line
                                    listethematiques.filter(a => a.precedent.toString() == 0).map((element, num) => <option key={num} value={element.id}>{element.nomafficher}</option>)
                                }
                            </select>
                        </div>
                        <div style={{ width: "100%", textAlign: "right !important" }}>
                            Variable :
                            <select id="variable1" className="semi-square" value={variable} onChange={changeVariable}>
                                {
                                    // eslint-disable-next-line
                                    listethematiques.filter(a => a.precedent.toString() == theme).map((element, num) => <option key={num} value={element.id}>{element.nomafficher.replace("$$", element.annee)}</option>)
                                }
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-12 tuile" id="reglages1" style={{ paddingTop: 0 }}>
                <div className="row">
                    <div className="col-4 tuile " style={{ textAlign: "right", display: "flex" }}>
                        Maille
                        <select id="signe1" style={{ minWidth: "33px !important" }} value={signe} onChange={changeSigne}>
                            <option value="inf">&#x2264;</option>
                            <option value="sup" >&#x2A7E;</option>
                        </select>
                    </div>
                    <div className="col-4 tuile " style={{ display: "flex" }}>
                        <select id="valeurstest1" value={valeurtest} onChange={changeValeurTest}>
                            {
                                variablecomplete === "" ?
                                    null
                                    :
                                    <>
                                        <option value={valeurs.min}>Min: {arrondir(valeurs.min)} {valeurafficher.unite}</option>
                                        <option value={valeurafficher.q1}>Q1 : {arrondir(valeurafficher.q1)} {valeurafficher.unite}</option>
                                        <option value={valeurafficher.q2}>Q2 : {arrondir(valeurafficher.q2)} {valeurafficher.unite}</option>
                                        <option value={valeurafficher.q3}>Q3 : {arrondir(valeurafficher.q3)} {valeurafficher.unite}</option>
                                        <option value={valeurafficher.qmoyenne}>Moy : {arrondir(valeurafficher.moyenne)} {valeurafficher.unite}</option>
                                        <option value="Saisie">Saisie manuelle</option>
                                        <option value={valeurs.max}>Max: {arrondir(valeurs.max)} {valeurafficher.unite}</option>
                                    </>

                            }
                        </select>
                        <div id='quantile2' style={{ paddingLeft: 5 }} onMouseOver={() => setAfficherBulleInformation(true)} onMouseOut={() => setAfficherBulleInformation(false)}>
                            <img alt='Information' src={`${process.env.PUBLIC_URL}/images/i_information.png`} />
                        </div>
                        {afficherbulleinformation ?
                            <div className={"infobulle"}>Qx correspond au Quartile x (division de l’ensemble des valeurs en 4 parties égales). Donc Q2, qui est le 2ième Quartile, correspond à la médiane (scinde la série en 2 groupes de valeurs de même effectif). Et, Q1 (1er Quartile) est tel que 25% des valeurs lui sont inférieures et 75% lui sont supérieures. Etc…</div>
                            :
                            null}
                    </div>
                    <div className="col-3 tuile ">
                        {
                            valeurtest === "Saisie" ?
                                <input type="number" id="valeurtestcustom1" size="5" style={{ width: "6em" }} value={valeursaisie} onChange={changeValeurSaisie} />
                                :
                                null
                        }
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 tuile " id="description1">
                    </div>
                </div>

            </div>
            <div className="col-12 tuile masquer description" id="description1"></div>
        </>
    )
}


function mapStateToProps(state) {
    return {
        listethematiques: state.listethematiques,
        territoire: state.territoire,
        theme2: state.theme2
    }
}

export default connect(mapStateToProps, { setTheme2, setAlerte })(Theme2);